export default __webpack_public_path__ + "static/media/Mobile-HOT-DEALS.395c6bd6.jpg";